import { createIcon } from '@chakra-ui/react'

export const CheckIcon = createIcon({
  displayName: 'Check',
  viewBox: '0 0 32 33',
  path: [
    <path
      key="path1"
      d="M28.709 10.2075L12.709 26.2075C12.6162 26.3005 12.5059 26.3742 12.3845 26.4246C12.2631 26.4749 12.1329 26.5008 12.0015 26.5008C11.8701 26.5008 11.74 26.4749 11.6186 26.4246C11.4972 26.3742 11.3869 26.3005 11.294 26.2075L4.29403 19.2075C4.10639 19.0199 4.00098 18.7654 4.00098 18.5C4.00098 18.2346 4.10639 17.9801 4.29403 17.7925C4.48167 17.6049 4.73617 17.4994 5.00153 17.4994C5.2669 17.4994 5.52139 17.6049 5.70903 17.7925L12.0015 24.0863L27.294 8.79251C27.4817 8.60487 27.7362 8.49945 28.0015 8.49945C28.2669 8.49945 28.5214 8.60487 28.709 8.79251C28.8967 8.98015 29.0021 9.23464 29.0021 9.50001C29.0021 9.76537 28.8967 10.0199 28.709 10.2075Z"
      fill="currentColor"
    />,
  ],
})
